module.exports = __webpack_public_path__ + "img/google-play-dark.75374443.svg";